import { render } from "./HomeIcon.vue?vue&type=template&id=3a53c212&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&lang=js"
export * from "./HomeIcon.vue?vue&type=script&lang=js"

import "./HomeIcon.vue?vue&type=style&index=0&id=3a53c212&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a53c212"]])

export default __exports__